/* Locale dispatcher.
 * Reads localStorage("locale") — "zh" or "en" — defaulting to "zh".
 * Re-exports all fields from the chosen portfolio content file.
 *
 * To change content, edit portfolio.zh.js or portfolio.en.js — NOT this file.
 */

const locale =
  (typeof window !== "undefined" &&
    window.localStorage &&
    window.localStorage.getItem("locale")) ||
  "zh";

const mod = locale === "en" ? require("./portfolio.en") : require("./portfolio.zh");

export const illustration = mod.illustration;
export const greeting = mod.greeting;
export const socialMediaLinks = mod.socialMediaLinks;
export const splashScreen = mod.splashScreen;
export const skillsSection = mod.skillsSection;
export const educationInfo = mod.educationInfo;
export const techStack = mod.techStack;
export const workExperiences = mod.workExperiences;
export const openSource = mod.openSource;
export const bigProjects = mod.bigProjects;
export const achievementSection = mod.achievementSection;
export const blogSection = mod.blogSection;
export const talkSection = mod.talkSection;
export const podcastSection = mod.podcastSection;
export const contactInfo = mod.contactInfo;
export const twitterDetails = mod.twitterDetails;
export const isHireable = mod.isHireable;
export const resumeSection = mod.resumeSection;
